class PricePromise extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('.js-modal');
    this.modalTrigger = this.querySelector('.js-modal-trigger');
    this.modalClose = this.querySelector('.js-modal-close');
    if (!this.modal || !this.modalTrigger || !this.modalClose) return;
    this.modalTrigger.addEventListener('click', () => this.showModal());
    this.modalClose.addEventListener('click', () => this.hideModal());
    this.modal.addEventListener('click', (event) => { if (event.target === this.modal) this.hideModal(); });
    this.modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.hideModal();
      if (event.key === 'Tab' && event.shiftKey && document.activeElement === this.modalClose) { event.preventDefault(); this.querySelector('iframe')?.focus(); }
    });
  }
  showModal() {
    this.modal.classList.add('is-active');
    this.modal.setAttribute('aria-hidden', 'false');
    this.modalTrigger.setAttribute('aria-expanded', 'true');
    this.modalClose.focus();
  }
  hideModal() {
    this.modal.classList.remove('is-active');
    this.modal.setAttribute('aria-hidden', 'true');
    this.modalTrigger.setAttribute('aria-expanded', 'false');
    this.modalTrigger.focus();
  }
}
if (!customElements.get('price-promise')) customElements.define('price-promise', PricePromise);
